import React from "react";
import {makeStyles} from "@mui/styles";
import SpeedDials from "./SpeedDials";
import {useTranslation} from "react-i18next";
import PropTypes from 'prop-types';
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import HomeIcon from "@mui/icons-material/Home";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

const useStyles = makeStyles((theme) => ({
    viewer: {
        height: props => props.height || "100%",
        width: "auto",
    },
}));

OpenSeaDragonViewer.propTypes = {
    viewerID: PropTypes.string.isRequired,
    showSpeedDial: PropTypes.bool,
    init: PropTypes.func.isRequired,
    viewer: PropTypes.object
}

OpenSeaDragonViewer.defaultProps = {
    viewerID: "issue-osd",
    showSpeedDial: true,
    init: null,
    viewer: null
}

export default function OpenSeaDragonViewer(props) {
    const classes = useStyles(props);
    const {t} = useTranslation("common");
    const {viewerID, showSpeedDial, init, viewer} = props;

    const actions = [
        {id: `${viewerID}-sd-zoom-in`, icon: <ZoomInIcon/>, name: t("main.components.speedDial.zoomIn")},
        {id: `${viewerID}-sd-zoom-out`, icon: <ZoomOutIcon/>, name: t("main.components.speedDial.zoomOut")},
        {id: `${viewerID}-sd-home`, icon: <HomeIcon/>, name: t("main.components.speedDial.home")},
        {id: `${viewerID}-sd-full-page`, icon: <FullscreenIcon/>, name: t("main.components.speedDial.fullScreen")},
    ];

    React.useEffect(() => {
        init();
        return () => {
            viewer && viewer.destroy();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [/* init will be exec one time*/]);

    return (
        <>
            {showSpeedDial && <SpeedDials actions={actions}/>}
            <div
                id={viewerID}
                className={classes.viewer}
            />
        </>
    );
}
